import React, { useEffect, useState } from 'react';
import { awsConfig } from '../aws-config';
import './LoginForm.css';

interface LoginFormProps {
  onAuthSuccess: (token: string) => void;
}

export const LoginForm: React.FC<LoginFormProps> = ({ onAuthSuccess }) => {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    
    if (code) {
      setLoading(true);
      exchangeCodeForToken(code);
      // Clean URL
      window.history.replaceState({}, document.title, window.location.pathname);
    }

    // Check for existing token
    const savedToken = localStorage.getItem('meppy_token');
    if (savedToken) {
      onAuthSuccess(savedToken);
    }
  }, [onAuthSuccess]);

  const exchangeCodeForToken = async (code: string) => {
    try {
      const tokenUrl = `https://${awsConfig.userPoolDomain}.auth.${awsConfig.region}.amazoncognito.com/oauth2/token`;
      
      // Client secret from Cognito configuration
      const clientSecret = '1okldvj8s5lshnhb7stn59q2alk5gtpocitvki1upkhnnejmvovk';
      const credentials = btoa(`${awsConfig.userPoolClientId}:${clientSecret}`);
      
      const response = await fetch(tokenUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Authorization': `Basic ${credentials}`,
        },
        body: new URLSearchParams({
          grant_type: 'authorization_code',
          code: code,
          redirect_uri: window.location.origin,
        }),
      });

      if (response.ok) {
        const tokens = await response.json();
        const idToken = tokens.id_token;
        const refreshToken = tokens.refresh_token;
        
        localStorage.setItem('meppy_token', idToken);
        localStorage.setItem('meppy_refresh_token', refreshToken);
        onAuthSuccess(idToken);
      } else {
        const errorData = await response.json();
        console.error('Token exchange error:', errorData);
        setError('Token exchange failed');
      }
    } catch (err) {
      console.error('Auth error:', err);
      setError('Authentication failed');
    } finally {
      setLoading(false);
    }
  };

  const handleSignIn = () => {
    const cognitoUrl = `https://meppy-auth-090600307342.auth.us-west-2.amazoncognito.com/login?client_id=5mtjq568v16ah7klq8mrg9010q&response_type=code&scope=openid+profile+email&redirect_uri=${encodeURIComponent(window.location.origin)}`;
    window.location.href = cognitoUrl;
  };

  if (loading) {
    return (
      <div className="login-container">
        <div className="login-form">
          <h2>Authenticating...</h2>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-form">
        <h2>Meppy Web</h2>
        <p>Methane Pyrolysis Research Agent</p>
        <p className="restriction-notice">
          Access restricted to Amazon employees (@amazon.com email required)
        </p>
        
        {error && <div className="error-message">{error}</div>}
        
        <button onClick={handleSignIn}>
          Sign In with Amazon Cognito
        </button>
      </div>
    </div>
  );
};
